import React from 'react';

const Graph = ({ size = 24, color = '#8940FA' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24">
    <path
      d="M1.72 1.09c-.4 0-.72.33-.72.74V22.1c0 .41.32.74.72.74h20.56c.4 0 .72-.33.72-.74a.73.73 0 0 0-.72-.74H2.43V1.83a.73.73 0 0 0-.71-.74zm14.35 5.2a.77.77 0 0 0-.76.77c.02.39.38.72.76.7h2.02l-6.36 6.18-2.29-1.97a.72.72 0 0 0-.6-.26.71.71 0 0 0-.43.2l-4.78 4.44a.8.8 0 0 0-.07 1.07c.25.3.75.31 1.03.04l4.32-4.03 2.3 1.99c.26.3.76.33 1.04.05l6.92-6.72v2.23c0 .39.34.75.72.75.38 0 .72-.36.72-.75V7.02a.75.75 0 0 0-.72-.74h-3.82z"
      strokeWidth=".5"
      stroke={color}
      fill={color}
    />
  </svg>
);

export default Graph;
